export default [
  {
    path: '/notificaciones',
    name: 'notificationSettings',
    component: () => import('@/views/notifications/NotificationSettings.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/notificaciones/:eventKey/:channel',
    name: 'notificationLog',
    component: () => import('@/views/notifications/NotificationLog.vue'),
    meta: {
      requiresAuth: true,
    },
  },
]
